const text_base = {
  fontFamily: 'Nunito',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '1.5em',
  fontSize: 16,
};

const text_variants = {
  base: { ...text_base },
  body1: {
    ...text_base,
  },
  'body1-bold': {
    ...text_base,
    fontWeight: 700,
  },
  body2: {
    ...text_base,
    fontSize: 14,
  },
  'body2-medium': {
    ...text_base,
    fontSize: 14,
    fontWeight: 600,
  },
  'body2-bold': {
    ...text_base,
    fontSize: 14,
    fontWeight: 800,
  },
  body3: {
    ...text_base,
    fontSize: 12,
    lineHeight: '1.33em',
  },
  'body3-medium': {
    ...text_base,
    fontSize: 12,
    lineHeight: '1.33em',
    fontWeight: 600,
  },
  'body3-bold': {
    ...text_base,
    fontSize: 12,
    lineHeight: '1.33em',
    fontWeight: 800,
  },
  title1: {
    ...text_base,
    fontSize: 48,
    lineHeight: '1.17em',
    fontWeight: 800,
    letterSpacing: '-0.01em',
  },
  'title1-mobile': {
    ...text_base,
    fontWeight: 800,
    letterSpacing: '-0.01em',
    fontSize: 32,
    lineHeight: '1.25em',
  },
  title2: {
    ...text_base,
    fontSize: 40,
    lineHeight: '1.2em',
    letterSpacing: '-0.01em',
  },
  'title2-bold': {
    ...text_base,
    fontSize: 40,
    lineHeight: '1.2em',
    letterSpacing: '-0.01em',
    fontWeight: 800,
  },
  'title2-bold-mobile': {
    ...text_base,
    letterSpacing: '-0.01em',
    fontWeight: 800,
    fontSize: 28,
    lineHeight: '1.29em',
  },
  title3: {
    ...text_base,
    fontSize: 32,
    lineHeight: '1.25em',
    letterSpacing: '-0.01em',
  },
  'title3-bold': {
    ...text_base,
    fontSize: 32,
    lineHeight: '1.25em',
    fontWeight: 800,
    letterSpacing: '-0.01em',
  },
  'title3-bold-mobile': {
    ...text_base,
    fontWeight: 800,
    letterSpacing: '-0.01em',
    fontSize: 20,
    lineHeight: '1.4em',
  },
  'title4-bold': {
    ...text_base,
    fontSize: 24,
    lineHeight: '1.33em',
    letterSpacing: '-0.01em',
    fontWeight: 800,
  },
  title5: {
    ...text_base,
    fontSize: 20,
    lineHeight: '1.4em',
  },
  'title5-bold': {
    ...text_base,
    fontSize: 20,
    lineHeight: '1.4em',
    fontWeight: 800,
  },
  subtitle1: {
    ...text_base,
    fontSize: 18,
    lineHeight: '1.44em',
    fontWeight: 600,
  },
  'subtitle1-mobile': {
    ...text_base,
    fontWeight: 600,
    fontSize: 16,
    lineHeight: '1.5em',
  },
  'subtitle1-bold': {
    ...text_base,
    fontSize: 18,
    lineHeight: '1.44em',
    fontWeight: 800,
  },
  subtitle2: {
    ...text_base,
    fontSize: 16,
  },
  'subtitle2-bold': {
    ...text_base,
    fontSize: 16,
    fontWeight: 800,
  },
  'subtitle3-bold': {
    ...text_base,
    fontSize: 14,
    lineHeight: '1.57em',
    fontWeight: 800,
  },
  caption1: {
    ...text_base,
    fontSize: 16,
    lineHeight: '1.25em',
    fontWeight: 800,
    letterSpacing: '0.02em',
    textTransform: 'uppercase',
  },
  caption2: {
    ...text_base,
    fontSize: 14,
    lineHeight: '1.29em',
    fontWeight: 800,
    letterSpacing: '0.02em',
    textTransform: 'uppercase',
  },
  caption3: {
    ...text_base,
    fontSize: 12,
    lineHeight: '1.33em',
    fontWeight: 800,
    letterSpacing: '0.02em',
    textTransform: 'uppercase',
  },
  'caption3-mobile': {
    ...text_base,
    fontWeight: 800,
    letterSpacing: '0.02em',
    textTransform: 'uppercase',
    fontSize: 10,
    lineHeight: '1.4em',
  },
  label1: {
    ...text_base,
    fontSize: 16,
    lineHeight: '1.25em',
    fontWeight: 800,
    letterSpacing: '0.02em',
    textTransform: 'uppercase',
  },
  label2: {
    ...text_base,
    fontSize: 14,
    lineHeight: '1.29em',
    fontWeight: 800,
    letterSpacing: '0.02em',
    textTransform: 'uppercase',
  },
  label3: {
    ...text_base,
    fontSize: 12,
    lineHeight: '1.33em',
    fontWeight: 800,
    letterSpacing: '0.02em',
    textTransform: 'uppercase',
  },
  hand1: {
    ...text_base,
    fontFamily: 'Caveat',
    fontWeight: 700,
    fontSize: 32,
    lineHeight: '1.38em',
  },
};

export default text_variants;
